export const sanitizeArticleText = (text = '') => {
  const sanitized = text.replace('<p>', '').replace('</p>', '');
  return { __html: sanitized };
};

export default sanitizeArticleText;
